import { useParams } from "react-router-dom";
import EpisodeList from "../../components/media/EpisodeList";
import MediaHero from "../../components/media/MediaHero";
import PeopleList from "../../components/media/PeopleList";
import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import useScrollTop from "../../hooks/useScrollTop";
import endpoints from "../../api/endpoints";
import { needsPurchase } from "./MoviePage";

const SeriesPage = () => {
  const { id } = useParams();
  const query = useApiQuery(endpoints.serie(id));
  useScrollTop([id]);

  return (
    <QueryBoundary {...query}>
      {(serie) => (
        <div>
          {/* Series carry no like/dislike, only a bookmark. */}
          <MediaHero media={serie} target="serie" showReactions={false} />
          {!needsPurchase(serie) && <EpisodeList episodes={serie.episodes} />}
          <PeopleList actors={serie.actors} />
        </div>
      )}
    </QueryBoundary>
  );
};

export default SeriesPage;
